import React, { useState, useEffect, useRef } from 'react';
import style from './AppSettings.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import { useNavigate } from "react-router-dom";
import ImgAvatarM from "../../../../images/common/i_3d_avatar_men.svg";

const AppSettings = () => {

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    //뒤로 가기
    const handleBack = () => {
        navigate(URL.TOTAL_MENU, { replace: true });
    };

    //세션 지우기
    const handleRemoveSession = () => {
        sessionStorage.removeItem("UrlRoot");
        navigate(URL.MY_HOSPITAL_SETTING);
    }

    //카카오 채널 이동 
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    }



    return (
        <>
            <HeadSub title="앱 설정" onBack={handleBack} />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-pad="normal">


                    <div className={style['top-box']}>
                        <div className={style['avatar-box']}>
                            <div className={style['avatar']}>
                                <object data={ImgAvatarM} aria-hidden='true' />
                            </div>
                            <p>
                                <b>{loginUser?.usrNm}</b> 님
                            </p>
                        </div>
                        <button className={style['write-btn']} onClick={() => navigate(URL.MYINFO_WRITE)}>
                            <span>내 정보 수정</span>
                        </button>
                    </div>

                    <div className={style['menu-box']}>
                        <ul>
                            <li>
                                <strong>설정</strong>
                                <ul>
                                    <li onClick={() => navigate(URL.APP_ALARM_SETTING)}>알림 설정 </li>
                                    <li onClick={() => navigate(URL.CUSTOM_DISEASE_SETTING)}>맞춤 질환 정보 설정 </li>
                                    {/* <li onClick={()=> navigate(URL.MY_HOSPITAL_SETTING)}>내 병원 설정 </li> */}
                                    <li onClick={() => handleRemoveSession()}>내 병원 설정 </li>
                                    <li onClick={() => navigate(URL.RECORD_SETTING)}>기록 일정 </li>
                                    <li onClick={() => navigate(URL.ACCESSIBILITY_SETTING)}>화면 고대비 설정 </li>
                                    <li onClick={() => navigate(URL.TTS_SETTING)}>음성 읽기 설정 </li>
                                </ul>
                            </li>

                            <li>
                                <strong>고객센터</strong>
                                <ul>
                                    <li onClick={() => navigate(URL.SERVICE_NOTICE)}>서비스 공지사항 </li>
                                    <li onClick={() => navigate(URL.SERVICE_USE_GUIDE)}>서비스 이용 가이드 </li>
                                    <li onClick={() => navigate(URL.SERVICE_FAQ_LISTS)}>자주찾는 질문 </li>
                                    <li onClick={() => navigate(URL.SERVICE_POLICY)}>서비스 약관 및 정책 </li>
                                    <li onClick={() => navigate(URL.APP_VERSION)}>앱 버전 정보 </li>
                                    <li onClick={() => navigate(URL.BUSINESS_INFORM)}>사업자 정보 </li>
                                    <li onClick={() => navigate(URL.ERROR_REPORT)}>문의 및 오류 제보</li>
                                </ul>
                            </li>
                            <li>
                                <strong>서비스 문의</strong>
                                <div className={style['btns-box']}>
                                    {/* <button className={style['normal']} onClick={()=>handlePhoneCall('1588-1511')}>
                                        <span>1588-1511</span>
                                    </button> */}
                                    <button className={style['kakao']} onClick={() => handleOnJoinMeeting('https://pf.kakao.com/_xlvxeHn/chat')}>
                                        <span>카카오톡으로 문의하기</span>
                                    </button>
                                    <div className={style['time-txt']}>
                                        <p><b>평일</b> 09:00~17:00 </p>
                                        <i>/</i>
                                        <p><b>점심시간</b> 12:00~13:00</p>
                                    </div>
                                </div>
                            </li>

                        </ul>
                    </div>

                </div>
            </div>
        </>
    );
};

export default AppSettings;
